module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("分页容器 - Tabs")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h2', [_vm._v("基本用法")]), _vm._v(" "), _c('uk-tabs', {
    attrs: {
      "active": _vm.tabIndex,
      "layout": _vm.tabLayout,
      "center": _vm.tabCenter,
      "width": _vm.tabWidth
    }
  }, [_c('uk-tab', {
    attrs: {
      "label": "Tab1"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.getContent()) + "\n    ")]), _vm._v(" "), _c('uk-tab', {
    attrs: {
      "label": "Tab2"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.getContent()) + "\n    ")]), _vm._v(" "), _c('uk-tab', {
    attrs: {
      "label": "Tab3"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.getContent()) + "\n    ")]), _vm._v(" "), _c('uk-tab', {
    attrs: {
      "disabled": true,
      "label": "Disabled"
    }
  }, [_vm._v("\n      Disabled content\n    ")])], 1), _vm._v(" "), _c('h3', [_vm._v("代码")]), _vm._v(" "), _c('code-block', [_vm._v(_vm._s(_vm.usages.basic))]), _vm._v(" "), _c('h3', [_vm._v("属性")]), _vm._v(" "), _c('table', {
    staticClass: "uk-table uk-table-striped uk-table-condensed"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('td', [_vm._v("0")]), _vm._v(" "), _c('td', [_vm._v("设置选中的页")]), _vm._v(" "), _c('td', {
    staticClass: "uk-form"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tabIndex),
      expression: "tabIndex"
    }],
    staticClass: "uk-width-1-1",
    attrs: {
      "type": "number",
      "max": "2",
      "min": "0"
    },
    domProps: {
      "value": _vm._s(_vm.tabIndex)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tabIndex = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('tr', [_vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('td', [_vm._v("\n        设置页的布局方式\n      ")]), _vm._v(" "), _c('td', {
    staticClass: "uk-form"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tabLayout),
      expression: "tabLayout"
    }],
    staticClass: "uk-width-1-1",
    on: {
      "change": function($event) {
        _vm.tabLayout = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "label": "undefined"
    }
  }), _vm._v(" "), _c('option', [_vm._v("flip")]), _vm._v(" "), _c('option', [_vm._v("left")]), _vm._v(" "), _c('option', [_vm._v("right")]), _vm._v(" "), _c('option', [_vm._v("bottom")])])])]), _vm._v(" "), _c('tr', [_vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('td', [_vm._v("是否将页居中显示")]), _vm._v(" "), _c('td', {
    staticClass: "uk-text-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tabCenter),
      expression: "tabCenter"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.tabCenter) ? _vm._i(_vm.tabCenter, null) > -1 : (_vm.tabCenter)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.tabCenter,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.tabCenter = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.tabCenter = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.tabCenter = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('tr', [_vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "uk-form"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tabWidth),
      expression: "tabWidth"
    }],
    staticClass: "uk-width-1-1",
    on: {
      "change": function($event) {
        _vm.tabWidth = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, [_c('option', [_vm._v("1-2")]), _vm._v(" "), _c('option', [_vm._v("1-3")]), _vm._v(" "), _c('option', [_vm._v("1-4")]), _vm._v(" "), _c('option', [_vm._v("1-5")]), _vm._v(" "), _c('option', [_vm._v("1-6")])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("属性")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")]), _vm._v(" "), _c('th', [_vm._v("说明")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "80px"
    }
  }, [_vm._v("试试")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("active")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("Boolean")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("layout")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("String")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('p', [_c('code', [_vm._v("undefined")])]), _vm._v("\n        以下为可选值：\n        "), _c('ul', [_c('li', [_c('code', [_vm._v("'flip'")]), _vm._v(" - 页头居右")]), _vm._v(" "), _c('li', [_c('code', [_vm._v("'left'")]), _vm._v(" - 垂直布局居左")]), _vm._v(" "), _c('li', [_c('code', [_vm._v("'right'")]), _vm._v(" - 垂直布局居右")]), _vm._v(" "), _c('li', [_c('code', [_vm._v("'bottom'")]), _vm._v(" - 页头居下")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("center")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("String")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("undefined")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("width")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("String")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("undefined")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-49822adb!./~/vue-loader/lib/selector.js?type=template&index=0!./src/docs/UkTabs.doc.vue
// module id = 290
// module chunks = 2